import React from 'react';
import { graphql } from 'gatsby';
import ProjectsDetailEn from './projectsDetailEn';

const Pages: React.FC<any> = (props) => <ProjectsDetailEn {...props} />;

export default Pages;

export const pageQuery = graphql`
  query ProjectsDetailTh($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    otherProjectsJp: allProjectsJpJson(
      sort: { fields: date, order: DESC }
      filter: { title: { rendered: { nin: ["dummy", null] } }, slug: { ne: $slug } }
    ) {
      edges {
        node {
          id
          title {
            rendered
          }
          slug
          acf {
            page_headline_ja
            card_headline_ja
            page_headline_en
            card_headline_en
            services {
              post_title
            }
            thumb
            client_name {
              en
              ja
            }
            client_abbr {
              en
              ja
            }
            product {
              ja
              en
            }
            outline
          }
        }
      }
    }
    otherProjects: allProjectsJson(
      sort: { fields: date, order: DESC }
      filter: { title: { rendered: { nin: ["dummy", null] } }, slug: { ne: $slug } }
    ) {
      edges {
        node {
          id
          title {
            rendered
          }
          slug
          acf {
            page_headline_ja
            card_headline_ja
            headline_en
            services {
              post_title
            }
            thumb
            client_name {
              en
              ja
            }
            client_abbr {
              en
              ja
            }
            product {
              ja
              en
            }
            outline
          }
        }
      }
    }
    shifterProjectsJpData: projectsJpJson(slug: { eq: $slug }) {
      acf {
        abstruct {
          contents {
            heading
            text
          }
          contents_ja {
            heading
            text
          }
          contents_en {
            heading
            text
          }
        }
        awards {
          award {
            post_title
          }
          prize
          url
        }
        client_abbr {
          en
          ja
        }
        product {
          ja
          en
        }
        client_name {
          en
          ja
        }
        credit {
          member
          role
        }
        credit_ptn {
          ja {
            member
            role
          }
          en {
            member
            role
          }
        }
        highlights {
          layout
          image
          image_mask
          contents {
            type
            value {
              number
              unit
              text
              notes {
                text
              }
            }
            comment {
              heading
              text
            }
            message {
              text
              name
              role
            }
          }
          ja {
            layout
            image
            image_mask
            contents {
              type
              value {
                number
                unit
                text
                notes {
                  text
                }
              }
              comment {
                heading
                text
              }
              message {
                text
                name
                role
              }
            }
          }
          en {
            layout
            image
            image_mask
            contents {
              type
              value {
                number
                unit
                text
                notes {
                  text
                }
              }
              comment {
                heading
                text
              }
              message {
                text
                name
                role
              }
            }
          }
        }
        process {
          ja {
            title
            text
          }
          en {
            title
            text
          }
        }
        page_headline_ja
        card_headline_ja
        headline_en
        kv
        kv_mask
        kv_sp
        kv_mask_sp
        launch
        modules_en {
          type
          appeal {
            fact {
              change
              number
              headline
              unit
            }
            text_en
            text
            layout
            label
            headline_en
            headline
          }
          basic_text {
            headline
            headline_en
            text
            text_en
          }
          feature {
            sub_contents {
              type
              value {
                number
                unit
                text
                notes {
                  text
                }
              }
              comment {
                heading
                text
              }
              message {
                text
                name
                role
                isDark
              }
              pic
            }
            headline
            img_right
            text
            text_en
          }
          pic_carousel {
            visuals {
              visual
              caption
            }
            size
          }
          pic_slider {
            pics {
              pic
            }
            rtl
            size
          }
          pic_double {
            pic1
            pic2
          }
          pic_triple {
            pic1
            pic2
            pic3
          }
          pic_sextuple {
            pic1
            pic2
            pic3
            pic4
            pic5
            pic6
          }
          visual_set {
            size
            visual
            caption
          }
          pic_large
          video_large
          youtube {
            size
            id
          }
          list_set {
            ol {
              li
            }
            ul {
              li
            }
            type
          }
          pic_and_messages {
            pic {
              url
            }
            messages {
              text
              name
              role
              isDark
            }
          }
        }
        overview_text {
          ja
          en
        }
        url
        top_show_area
        thumb
        outline
        link_area {
          links {
            link_list {
              label
              url
            }
            title
          }
        }
      }
      slug
      title {
        rendered
      }
    }
    shifterProjectsData: projectsJson(slug: { eq: $slug }) {
      acf {
        awards {
          award {
            post_title
          }
          prize
          url
        }
        client_abbr {
          en
          ja
        }
        product {
          ja
          en
        }
        client_name {
          en
          ja
        }
        credit {
          member
          role
        }
        credit_ptn {
          member
          role
        }
        page_headline_ja
        card_headline_ja
        headline_en
        kv
        kv_sp
        launch
        modules {
          type
          appeal {
            fact {
              change
              number
              headline
              unit
            }
            text_en
            text
            layout
            label
            headline_en
            headline
          }
          basic_text {
            headline
            headline_en
            text
            text_en
          }
          feature {
            pics {
              pic
            }
            headline
            headline_en
            img_right
            text
            text_en
          }
          pic_carousel {
            visuals {
              visual
              caption
            }
            size
          }
          pic_slider {
            pics {
              pic
            }
            rtl
            size
          }
          pic_double {
            pic1
            pic2
          }
          pic_triple {
            pic1
            pic2
            pic3
          }
          pic_sextuple {
            pic2
            pic1
            pic3
            pic4
            pic5
            pic6
          }
          visual_set {
            size
            visual
            caption
          }
          pic_large
          video_large
          youtube {
            size
            id
          }
          list_set {
            ol {
              li
            }
            ul {
              li
            }
            type
          }
        }
        overview_text {
          ja
          en
        }
        product {
          ja
          en
        }
        services {
          post_title
        }
        studios {
          post_title
        }
        url
        top_show_area
        thumb
        outline
      }
      slug
      title {
        rendered
      }
    }
    shifterAwardsEnData: allShifterProjectsData(filter: { slug: { eq: $slug } }, limit: 1) {
      nodes {
        acf {
          awards {
            award {
              post_title
            }
            prize
            url
          }
        }
        slug
      }
    }
    allShifterAwardsData {
      nodes {
        acf {
          logo
        }
        title {
          rendered
        }
      }
    }
  }
`;
